export const googletrackStorePageView = ({
  pageName,
  storeName,
  zipcode,
  customerEmail,
  device_id,
  promo,
  influe,
  fingerPrint,
}) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  // Send a page_view with custom params
  window.gtag('event', 'page_view', {
    page_title: pageName || 'StoreList',
    page_location: window.location.href,
    page_path: window.location.pathname,
    store_name: storeName || 'none',
    zipcode: zipcode || 'none',
    customerEmail: customerEmail || 'none',
    device_id: device_id || 'none',
    promo: promo || 'none',
    influe: influe || 'none',
    fingerPrint: fingerPrint || 'none',
  });
};
